<template>
	<vs-prompt
		:active.sync="activePrompt"
		:buttons-hidden="true"
		:title="$t('resultGlovalSearchOrderById')"
		button-accept="false"
		button-cancel="filled"
		:cancel-text="$t('close')"
		color="warning"
	>
		<div class="con-exemple-prompt">
			{{ $t('textNoResultGlovalSearchOrderById') }} <b>{{ orderNumber }}</b>
			<div class="flex justify-end mt-8">
				<vs-button
					@click="accept"
					color="warning"
				>{{ $t('close') }}</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ResultSearchGlobalOrderById",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		orderNumber: {
			required: true,
		}
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept");
		}
	}
};
</script>
